//@ts-check
import { AppConstants, AccountConstants } from "../../constants/constants";
import { refresh, refreshAccount } from "./accountAction";
import commomAction from "./commomAction";
import axios from "axios";
import { getfetchopts } from "../../utils/fetchutils.js";
import { logout } from "../../utils/store";

function init() {
  return async (dispatch) => {
    try {
      await dispatch(refresh());
      dispatch(loadCustomers());
    } catch (e) {
      // Refresh might fail, that's ok
      console.log("Init refresh failed:", e.message);
    }

    const sites = sessionStorage.getItem(AppConstants.CURRENT_CUSTOMER)
      ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_CUSTOMER))
      : null;
    const organization = sessionStorage.getItem(AppConstants.CURRENT_ORGANIZATION)
      ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_ORGANIZATION))
      : null;
    const location = sessionStorage.getItem(AppConstants.CURRENT_LOCATION)
      ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_LOCATION))
      : null;
    const accountId = sessionStorage.getItem(AppConstants.CURRENT_ACCOUNT)
      ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_ACCOUNT))
      : null;
    const current_language = sessionStorage.getItem(AppConstants.CURRENT_LANGUAGE)
      ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_LANGUAGE))
      : null;
    //api verify auth
    dispatch({
      type: AppConstants.INIT_APP,
    });

    dispatch({
      type: AppConstants.CURRENT_CUSTOMER,
      data: sites,
    });
    dispatch({
      type: AppConstants.CURRENT_ORGANIZATION,
      payload: organization,
    });
    dispatch({
      type: AppConstants.CURRENT_LOCATION,
      payload: location,
    });
    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
      payload: accountId,
    });
    if (current_language) {
      dispatch({
        type: AppConstants.SET_APP_LANGUAGE,
        payload: current_language,
      });
    }
  };
}

function setCurrentCustomer(id) {
  return (dispatch) => {
    sessionStorage.setItem(AppConstants.CURRENT_CUSTOMER, encodeURIComponent(id));
    dispatch({
      type: AppConstants.CURRENT_CUSTOMER,
      data: id,
    });
  };
}

function loading() {
  return (dispatch) =>
    dispatch({
      type: AppConstants.LOADING_START,
    });
}

function loaded() {
  return (dispatch) =>
    dispatch({
      type: AppConstants.LOADING_END,
    });
}

function setTitle(title) {
  return (dispatch) =>
    dispatch({
      type: AppConstants.SET_TITLE,
      data: title,
    });
}

function loadCustomers() {
  return async (dispatch) => {
    //const res = await app.customers({}, {}, {
    //    current: 1,
    //    pageSize: 999,
    //});
    const res = JSON.parse(
      `{"data":[{"id":"304be86a-4034-4c8b-9110-9389ac71e223","customerName":"Vanilla Solutions","email":"qwe@qwe.com","companyName":"Vanilla Solutions","country":"United States","industry":"Information Technology","province":"Boston","alertType":"Fleet","alertStatus":"Acknowledged","phone":"6548542695","customerStatus":"Enabled","createTime":"2019-09-21T11:05:50.000Z"},{"id":"304be86a-4034-4c8b-9110-9389ac71e29f","customerName":"Vanilla Solutions - B","email":"qwe@qwe.com","companyName":"Vanilla Solutions - B","country":"United States","industry":"Information Technology","province":"Lansing","alertType":"Fleet","alertStatus":"Acknowledged","phone":"6548542695","customerStatus":"Enabled","createTime":"2019-09-21T12:30:09.000Z"}],"recordsFiltered":0,"recordsTotal":2}`
    );

    dispatch({
      type: AppConstants.LOAD_CUSTOMERS,
      data: res.data,
    });
  };
}

function setMenus(menus) {
  return (dispatch) => {
    dispatch({
      type: AppConstants.SET_MENUS,
      payload: menus,
    });
  };
}

function setCurrentActiveMenu(key) {
  return (dispatch) => {
    dispatch({
      type: AppConstants.SET_CURRENT_ACTIVE_MENU,
      payload: key,
    });
  };
}

function setCurrentPageInfo(title, currentActiveMenu) {
  return (dispatch) => {
    dispatch({
      type: AppConstants.SET_CURRENT_PAGE_INFO,
      payload: {
        title,
        currentActiveMenu,
      },
    });
  };
}

function setCurrentAccount(id) {
  return async (dispatch) => {
    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
      payload: null,
    });
    dispatch({
      type: AppConstants.CURRENT_ORGANIZATION,
      payload: "",
    });
    dispatch({
      type: AppConstants.CURRENT_LOCATION,
      payload: "",
    });
    sessionStorage.removeItem(AppConstants.CURRENT_ORGANIZATION);
    sessionStorage.removeItem(AppConstants.CURRENT_LOCATION);

    try {
      const config = getfetchopts({
        method: "PUT",
        url: "/api/accounts/set-account",
        data: { account_id: id },
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
    } catch (e) {
      console.error("Error:", e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw e;
    }

    sessionStorage.setItem(AppConstants.CURRENT_ACCOUNT, encodeURIComponent(id));

    await dispatch(refresh());

    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
      payload: id,
    });
    //clear

    // await dispatch(refresh());
    // dispatch(commomAction.getLocations());
    // dispatch(commomAction.getOrganizations());
    // dispatch(commomAction.getLocationOptions());
    // await dispatch(setCurrentLocation(""));
  };
}

function setCurrentOrganization(id, opts = {}) {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "PUT",
        url: "/api/identity/org/set-current",
        data: { organizationId: id },
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
    } catch (e) {
      console.error("Error:", e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw e;
    }

    sessionStorage.setItem(AppConstants.CURRENT_ORGANIZATION, encodeURIComponent(id));
    let curSignature;
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/core/fs/signature",
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
      curSignature = result.data;
    } catch (e) {
      console.error("Error:", e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw e;
    }
    const { urlprefix, signature } = curSignature;
    sessionStorage.setItem(AppConstants.FS_URL_PREFIX, encodeURIComponent(urlprefix));
    sessionStorage.setItem(AppConstants.FS_URL_SIGNATURE, encodeURIComponent(signature));
    dispatch({
      type: AppConstants.CURRENT_ORGANIZATION,
      payload: id,
    });

    // dispatch(commomAction.getLocations());
    // dispatch(commomAction.getOrganizations());
    // dispatch(commomAction.getLocationOptions());

    await dispatch(setCurrentLocation(""));
    await dispatch(refreshAccount());

    // If this was invoked from the cross-tab listener, reload after state settles
    try {
      if (opts && opts.fromBroadcast) {
        window.location.reload();
      } else {
        // Notify other tabs (simple BroadcastChannel use)
        if ("BroadcastChannel" in window) {
          const bc = new BroadcastChannel("amie-session");
          bc.postMessage({ type: "org-changed", organizationId: id });
          bc.close();
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
}

function setUserTimezone(timezone, date_format, time_format) {
  return async (dispatch) => {
    let newToken;
    try {
      const config = getfetchopts({
        method: "PUT",
        url: `/api/identity/user/update-profile`,
        data: {
          timezone,
          date_format,
          time_format,
        },
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
      newToken = result.data;
    } catch (e) {
      console.error("Error:", e);
      if (e.response && e.response.status === 401) {
        logout();
      }
      throw e;
    }
    // dispatch({ type: "CLEAR_DATA" });

    let current;
    try {
      const config = getfetchopts({
        method: "GET",
        url: "/api/accounts/current",
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
      current = result.data;
    } catch (e) {
      console.error("Error:", e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw e;
    }

    dispatch({
      type: AccountConstants.SIGN_IN,
      data: current,
    });
  };
}

function setCurrentLocation(id) {
  return async (dispatch) => {
    try {
      const config = getfetchopts({
        method: "PUT",
        url: "/api/locations/set-current",
        data: { location_id: id },
      });
      const result = await axios.request(config);
      console.info("Reply:", result);
    } catch (e) {
      console.error("Error:", e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw e;
    }


    dispatch({
      type: "CLEAR_DATA",
    });
    sessionStorage.setItem(AppConstants.CURRENT_LOCATION, encodeURIComponent(id));
    dispatch({
      type: AppConstants.CURRENT_LOCATION,
      payload: id,
    });

    await dispatch(initGlobalData());

  };
}
function setAdminAccount(id) {
  return async (dispatch) => {
    dispatch({
      type: AppConstants.ADMIN_ACCOUNT,
      payload: "",
    });
    dispatch({
      type: AppConstants.ADMIN_ORGANIZATION,
      payload: "",
    });

    dispatch({
      type: AppConstants.ADMIN_ACCOUNT,
      payload: id,
    });
  };
}

function setAdminOrganization(id) {
  return async (dispatch) => {
    dispatch({
      type: AppConstants.ADMIN_ORGANIZATION,
      payload: id,
    });
  };
}

function initGlobalData() {
  return async (dispatch) => {
    const locationsPromise = dispatch(commomAction.getLocationOptions());

    dispatch(commomAction.getOrganizations());
    dispatch(commomAction.getRolegetOptions());
    dispatch(commomAction.getTimeZones());

    await locationsPromise;
    dispatch(commomAction.getLocations());
    dispatch(commomAction.getSettingsList());
  };
}

function setLanguage(languageCode) {
  return async (dispatch) => {
    sessionStorage.setItem(AppConstants.CURRENT_LANGUAGE, encodeURIComponent(languageCode || ""));
    dispatch({
      type: AppConstants.SET_APP_LANGUAGE,
      payload: languageCode,
    });
  };
}
function setNotificationTimeRange(range) {
  return (dispatch) => {
    dispatch({
      type: AppConstants.SET_NOTIFICATION_TIME_RANGE,
      payload: range,
    });
  };
}

export default {
  init,
  setTitle,
  loadCustomers,
  loading,
  loaded,
  setCurrentCustomer,
  setCurrentActiveMenu,
  setCurrentPageInfo,
  setCurrentOrganization,
  setCurrentLocation,
  initGlobalData,
  setMenus,
  setUserTimezone,
  setCurrentAccount,
  setLanguage,
  setAdminAccount,
  setAdminOrganization,
  setNotificationTimeRange,
};
